import { render, staticRenderFns } from "./MypageSwitchToPaidPlanPane.vue?vue&type=template&id=04c16750&scoped=true"
import script from "./MypageSwitchToPaidPlanPane.vue?vue&type=script&lang=ts"
export * from "./MypageSwitchToPaidPlanPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageSwitchToPaidPlanPane.vue?vue&type=style&index=0&id=04c16750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c16750",
  null
  
)

export default component.exports